import { createAction } from 'redux-actions';
import { CALL_API } from '../constants';
import { saveBlobFile } from '../../../util/helpers';

const ExportService = {
  getPdf: createAction(CALL_API, (userId, fileName, config) => ({
    body: config,
    method: 'POST',
    path: `/export/user/${userId}`,
    handleResponse: response => {
      return saveBlobFile(response, fileName);
    },
    handleError: () =>
      Promise.reject('Something went wrong. Please try again.'),
    responseType: 'blob',
  })),
  getTerms: createAction(CALL_API, () => ({
    body: undefined,
    method: 'GET',
    path: '/export/terms',
    handleResponse: response => {
      return saveBlobFile(response, 'TOS_and_PP_for_Pediatric_Palliative_Care');
    },
    handleError: () =>
      Promise.reject('Something went wrong. Please try again.'),
    responseType: 'blob',
  })),
};

export default ExportService;



// WEBPACK FOOTER //
// ./src/lib/dataLayer/export/ExportService.js